import { z } from "zod";

export const reserveUsageSchema = z.object({
  usageType: z.string().trim().min(1),
  quantity: z.number().int().positive()
});

export const commitUsageSchema = z.object({
  reservationId: z.string().trim().min(1),
  quantity: z.number().int().positive().optional()
});

export const cancelUsageSchema = z.object({
  reservationId: z.string().trim().min(1)
});

export type UsageReservationInput = z.infer<typeof reserveUsageSchema>;
export type UsageCommitInput = z.infer<typeof commitUsageSchema>;
export type UsageCancelInput = z.infer<typeof cancelUsageSchema>;

export type UsageReservationStatus =
  | "reserved"
  | "committed"
  | "cancelled"
  | "expired";

export interface UsageQuotaView {
  usageType: string;
  limit: number;
  committed: number;
  reserved: number;
  remaining: number;
}

export interface UsageReservationView {
  reservationId: string;
  tenantId: string;
  usageType: string;
  quantity: number;
  committedQuantity: number;
  releasedQuantity: number;
  status: UsageReservationStatus;
  createdAt: string;
  updatedAt: string;
  expiresAt: string;
}

export interface QuotaState {
  tenantId: string;
  quotas: UsageQuotaView[];
}
